import { Link } from 'react-router-dom';

export default function HeroBanner() {
  return (
    <section className="relative w-full h-[440px] md:h-[580px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Cinematic%20key%20visual%20poster%20for%20a%20modern%20Chinese%20family%20drama%2C%20moody%20warm%20amber%20and%20deep%20blue%20tones%2C%20silhouettes%20of%20a%20mother%20and%20daughter%20standing%20by%20a%20large%20window%20overlooking%20a%20city%20at%20dusk%2C%20soft%20lamp%20glow%2C%20artistic%20stylized%20composition%2C%20strong%20contrast%2C%20cinematic%20depth%20of%20field%2C%20refined%20editorial%20photography&width=1600&height=900&seq=drama-hero-banner-2024&orientation=landscape"
        alt="女友的妈妈 电视剧焦点宣传图 母女窗边剪影"
        title="女友的妈妈 电视剧全集及剧情介绍"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-primary-950/90 via-primary-950/65 to-primary-950/30"></div>

      <div className="relative w-full h-full px-4 md:px-8 flex flex-col justify-center">
        <div className="max-w-[1280px] mx-auto w-full">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-medium">
              <i className="ri-fire-line"></i>
              全集已完结 · 共 12 集
            </span>
            <h1 className="font-heading text-3xl md:text-5xl font-bold text-background-50 mt-4 leading-tight">
              女友的妈妈
            </h1>
            <p className="text-background-200 text-sm md:text-base leading-relaxed mt-4 max-w-xl">
              一段恋爱，两代人的秘密。当年轻人第一次走进女友的家门，
              餐桌上的每一句寒暄，都在悄悄丈量彼此的距离。
            </p>

            <div className="flex flex-wrap items-center gap-3 mt-6">
              <Link
                to="/episodes"
                className="px-5 py-2.5 rounded-md bg-accent-500 hover:bg-accent-600 text-background-50 text-sm font-medium whitespace-nowrap transition-colors cursor-pointer"
              >
                查看全集
              </Link>
              <Link
                to="/actors"
                className="px-5 py-2.5 rounded-md border border-background-200/60 text-background-50 hover:bg-background-50/10 text-sm whitespace-nowrap transition-colors cursor-pointer"
              >
                演员阵容
              </Link>
            </div>

            <div className="mt-6 flex items-start gap-2 text-background-200 text-xs md:text-sm">
              <i className="ri-notification-3-line text-accent-300 mt-0.5"></i>
              <span>
                最新：大结局《和解》已上线，主题曲《窗边》同步发布
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}